import React from 'react';
import './Footer.css';

// Cache-busting version for logo (update this when logo changes)
const LOGO_VERSION = '2.0';

const Footer = ({ onSectionChange }) => {
  const handleSectionClick = (sectionId, e) => {
    e.preventDefault();
    if (onSectionChange) {
      onSectionChange(sectionId);
    }
    // Scroll to top when changing sections
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img 
              src={`/rivontrix-logo-white.svg?v=${LOGO_VERSION}`}
              alt="Rivontrix - Your Technology Partner" 
              className="footer-logo"
              width="240" 
              height="75"
              loading="eager"
            />
            <p>
              A next-generation technology and consulting firm combining AI-driven cybersecurity 
              products with digital transformation and manpower expertise.
            </p>
            <div className="social-links">
              <a href="https://www.linkedin.com/company/rivontrix" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
              <a href="#" aria-label="X (formerly Twitter)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="16" fill="currentColor">
                  <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
                </svg>
              </a>
              <a href="#" aria-label="GitHub"><i className="fab fa-github"></i></a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Our Divisions</h4>
            <ul>
              <li><a href="#divisions" onClick={(e) => handleSectionClick('divisions', e)}>Rivontrix Consulting</a></li>
              <li><a href="#divisions" onClick={(e) => handleSectionClick('divisions', e)}>ShieldEx</a></li>
              <li><a href="#divisions" onClick={(e) => handleSectionClick('divisions', e)}>TechTalentPro</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services" onClick={(e) => handleSectionClick('services', e)}>AI-Powered Security</a></li>
              <li><a href="#services" onClick={(e) => handleSectionClick('services', e)}>Generative AI (GenAI)</a></li>
              <li><a href="#services" onClick={(e) => handleSectionClick('services', e)}>Cloud Migration</a></li>
              <li><a href="#services" onClick={(e) => handleSectionClick('services', e)}>Data Engineering</a></li>
              <li><a href="#services" onClick={(e) => handleSectionClick('services', e)}>Digital Transformation</a></li>
              <li><a href="#services" onClick={(e) => handleSectionClick('services', e)}>Talent Placement</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="#industries" onClick={(e) => handleSectionClick('industries', e)}>Industries</a></li>
              <li><a href="#insights" onClick={(e) => handleSectionClick('insights', e)}>Insights</a></li>
              <li><a href="#services" onClick={(e) => handleSectionClick('services', e)}>Services</a></li>
              <li><a href="#divisions" onClick={(e) => handleSectionClick('divisions', e)}>Divisions</a></li>
              {/* <li><a href="#partnership" onClick={(e) => handleSectionClick('partnership', e)}>Partner & Invest</a></li> */}
              <li><a href="#careers" onClick={(e) => handleSectionClick('careers', e)}>Careers</a></li>
              <li><a href="#about" onClick={(e) => handleSectionClick('about', e)}>About Us</a></li>
              <li><a href="#contact" onClick={(e) => handleSectionClick('contact', e)}>Contact Us</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 Rivontrix Solutions Pte Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

